import React from 'react';
import { Page } from '../../../ui';
import SearchResults from './SearchResult';

/**
 * Shared dashboard layout component that provides consistent structure
 * across all dashboard types.
 */
const DashboardLayout = ({
  children,
  dashboardData,
  showSearchResults = false
}) => {
  return (
    <Page>
      {/* Dashboard-specific content */}
      {showSearchResults ? (
        <SearchResults courses={dashboardData || []} />
      ) : (
        children
      )}
    </Page>
  );
};

export default DashboardLayout;
